<template>
  <VAvatar
    :size="$vuetify.breakpoint.smAndDown ? 60 : size"
    max-width="100%"
    :color="logo ? 'white' : 'grey'"
    tile
    class="mr-md-0 my-md-4"
  >
    <VImg
      v-if="logo"
      aspect-ratio="1"
      :src="logo.file.url"
    />
    <span v-else class="white--text headline">{{ shortTitle }}</span>
  </VAvatar>
</template>

<script>
import { mdiCheckboxBlankOutline } from '@mdi/js';

export default {
  name: 'CompanyLogo',
  props: {
    logo: {
      required: true,
      validator: prop => typeof prop === 'object' || prop === null,
    },
    title: {
      type: String,
      required: true,
    },
    size: {
      type: Number,
      default: 140,
    },
  },
  data() {
    return {
      emptyLogoIcon: mdiCheckboxBlankOutline,
    };
  },
  computed: {
    shortTitle() {
      return this.title.split(/\s/)
        .reduce((response, word) => response + word.slice(0, 1), '');
    },
  },
};
</script>
